export enum StoreProvider {
  WooCommerce = "woocommerce",
  YouCan = "youcan",
  EasyOrders = "easyOrders",
  Dukan = "dukan",
  Zid = "zid",
  LightFunnels = "lightfunnels",
  Salla = "salla",
}
